export default "__VITE_ASSET__31ea16a4__"